export const Section = ({ children, className = "" }) => (
  <section className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</section>
);

export const SectionHead = ({ eyebrow, title, desc, right }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div>
      {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
      <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-white">{title}</h2>
      {desc && <p className="text-slate-400 mt-2 max-w-2xl text-sm sm:text-base">{desc}</p>}
    </div>
    {right}
  </div>
);

export const AdSlot = ({ label = "Advertisement", testid = "ad-slot" }) => (
  <div data-testid={testid} className="rounded-xl border border-dashed border-white/15 bg-[#111827]/60 px-6 py-5 text-center">
    <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mb-1">{label}</p>
    <p className="text-slate-400 text-sm">Clearly labeled placement available — <a href="/advertise" className="text-[#3B82F6] hover:underline">Advertise with DYORUSA</a></p>
  </div>
);

export const SourceLink = ({ source }) => (
  <a href={source.url} target="_blank" rel="noopener noreferrer"
    className="inline-flex items-start gap-1.5 text-[13px] text-[#3B82F6] hover:text-[#84CC16] transition-colors">
    <span className="underline underline-offset-2">{source.label}</span>
    {source.date && <span className="text-slate-500 font-mono text-[11px]">· {source.date}</span>}
  </a>
);
